
<app-power-bi-report *ngIf="reportType == 'PowerBI'"></app-power-bi-report>
<app-superset-report *ngIf="reportType == 'SuperSet'"></app-superset-report>